import React from "react";
import { Link } from "react-router-dom";
import HomeLayout from "../layouts/home";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { useTranslation } from "../contexts/I18nProvider";

function Help() {
  const { t } = useTranslation();
  return (
    <HomeLayout>
      <div className="flex flex-col gap-8">
        <div className="rounded-2xl border border-border/40 bg-white/95 px-8 py-10 shadow-sm">
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">
            {t('pages.help.title')}
          </p>
          <h1 className="mt-3 text-4xl font-bold text-primary">
            {t('pages.help.heading')}
          </h1>
          <p className="mt-4 max-w-3xl text-lg text-text-secondary">
            {t('pages.help.description')}
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          <Card className="bg-white/95 border border-border/40 rounded-2xl shadow-sm">
            <CardHeader>
              <CardTitle className="text-primary">{t('pages.help.searchByCountry')}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-sm text-text-secondary">
              <p>
                {t('pages.help.searchByCountryDesc')}
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Nigeria</li>
                <li>Bamileke</li>
                <li>Cameroon</li>
                <li>South Africa</li>
              </ul>
              <p className="text-xs">
                Accents and minor typos are handled automatically, so searches
                like "bamiléké" or "nigerai" still work.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white/95 border border-border/40 rounded-2xl shadow-sm">
            <CardHeader>
              <CardTitle className="text-primary">{t('pages.help.searchSentences')}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-sm text-text-secondary">
              <p>
                {t('pages.help.searchSentencesDesc')}
              </p>
              <p className="text-xs">
                {t('pages.help.freePlanNote')}
              </p>
            </CardContent>
          </Card>
        </div>

        <Card className="bg-white/95 border border-border/40 rounded-2xl shadow-sm">
          <CardHeader>
            <CardTitle className="text-primary">{t('pages.help.whySupport')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-text-secondary">
            <p>
              {t('pages.help.supportText')}
            </p>
            <p>
              {t('pages.help.helpGrow')}
            </p>
            <div className="flex flex-wrap gap-3 pt-4">
              <Link
                to="/pricing"
                className="inline-flex items-center rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-white hover:bg-primary-dark transition-colors"
              >
                {t('pages.help.viewPlans')}
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center rounded-lg border border-border/60 bg-white px-6 py-2.5 text-sm font-semibold text-primary hover:bg-accent/20 transition-colors"
              >
                {t('pages.help.contactResultam')}
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </HomeLayout>
  );
}

export default Help;
